import ChangePasswordForm from '../components/forms/auth/change-password';

const ChangePassword = () => (<ChangePasswordForm/>);
  
export default ChangePassword;